module.exports = __webpack_public_path__ + "static/media/collaboration.39f81753.webp";